module.exports = __webpack_public_path__ + "img/extended.56c6c7ca.png";